import { styled } from "styled-components";

export const SectionContainer = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.md};

  @media (max-width: 767px) {
    font-size: 1.2rem;
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: ${({ theme }) => theme.spacing.md} 0;

  &::before {
    content: "";
    width: 4%;
    height: 1px;
    border: none;
    background-color: #d5d6d2;
    margin: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  }

  &::after {
    content: "";
    width: 68%;
    height: 1px;
    border: none;
    background-color: #d5d6d2;
    margin: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  }

  @media (max-width: 767px) {
    &::before {
      width: 16%;
    }

    &::after {
      width: 68%;
    }
  }
`;

export const Container = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.lg};
  padding: ${({ theme }) => `0px ${theme.spacing.lg}`};
  /* justify-content: center; */
`;

export const SectionTitle = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: bold;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.primary};
  margin: ${({ theme }) => `${theme.spacing.md} 0px ${theme.spacing.md} 0px`};

  @media (max-width: 767px) {
    font-size: 1.2rem;
    margin: ${({ theme }) => `${theme.spacing.sm} 0px ${theme.spacing.sm} 0px`};
  }
`;

export const EmptyConfiguration = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: bold;
  white-space: nowrap;
`;
